import { render, staticRenderFns } from "./ModalNewUsers.vue?vue&type=template&id=8a8b0b9c&"
import script from "./ModalNewUsers.vue?vue&type=script&lang=js&"
export * from "./ModalNewUsers.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewUsers.vue?vue&type=style&index=0&id=8a8b0b9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports